export const ReadAppVersion = async () => {
  const controller = new AbortController();
  const timer = window.setTimeout(() => controller.abort(), 10000);
  try {
    const response = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store', signal: controller.signal });
    if (!response.ok) return null;
    const data = await response.json();
    return typeof data?.version === 'string' && data.version.trim() ? data.version.trim() : null;
  } catch (error) {
    return null;
  } finally {
    window.clearTimeout(timer);
  }
};
